/**
 * Client session — persisted bearer for TAP / history APIs.
 */
const STORAGE_KEY = 'itemiz_session';

export function getStoredSession() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function storeSession(session) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(session));
}

export async function ensureSession() {
  const existing = getStoredSession();
  if (existing?.session_token && existing?.user_id) {
    const exp = new Date(existing.expires_at || 0);
    if (exp.getTime() > Date.now() + 60_000) return existing;
  }

  const res = await fetch('/api/v1/session', { method: 'POST' });
  if (!res.ok) throw new Error('Could not start session');
  const session = await res.json();
  storeSession(session);
  return session;
}

export function authHeaders(extra = {}) {
  const s = getStoredSession();
  const headers = { ...extra };
  if (s?.session_token) {
    headers.Authorization = `Bearer ${s.session_token}`;
  }
  return headers;
}
